var map = {
	"./animations/confetti": "b21c",
	"./animations/confetti.json": "b21c",
	"./animations/happy-smiley": "46c8",
	"./animations/happy-smiley-small": "5919",
	"./animations/happy-smiley-small.json": "5919",
	"./animations/happy-smiley.json": "46c8",
	"./animations/meh-smiley": "9e1e",
	"./animations/meh-smiley-small": "0834",
	"./animations/meh-smiley-small.json": "0834",
	"./animations/meh-smiley.json": "9e1e",
	"./animations/unsure-smiley-small": "45e4",
	"./animations/unsure-smiley-small.json": "45e4",
	"./common/big-percentage.svg": "2466",
	"./common/biometric-id.svg": "3b95",
	"./common/crunched-smiley.svg": "8b14",
	"./common/female.svg": "beb0",
	"./common/happy-smiley.svg": "f199",
	"./common/male.svg": "8785",
	"./common/meh-smiley.svg": "9f36",
	"./common/not-sure-smiley.svg": "d754",
	"./common/satisfied-smiley.svg": "802e",
	"./common/social-id-uploaded-successfuly.svg": "bac0",
	"./common/social/ella.png": "4f1f",
	"./common/standard-id.svg": "d086",
	"./fonts/SimplerPro_Alte-Black.otf": "60c2",
	"./fonts/SimplerPro_V3-Bold.otf": "a927",
	"./fonts/SimplerPro_V3-Regular.otf": "4986",
	"./icons/whatsapp-icon.svg": "1f60",
	"./lightup/gift.svg": "ec0a",
	"./lightup/good-question.svg": "c426",
	"./lightup/house.svg": "8c6e",
	"./lightup/kids.svg": "1d86",
	"./lightup/pension.svg": "a794",
	"./meitav-dash/combined-logo.svg": "e10a",
	"./meitav-dash/commission-slide.svg": "10d4",
	"./meitav-dash/confetti.svg": "b802",
	"./meitav-dash/meitav-dash-present.svg": "62b6",
	"./meitav-dash/one-time-deposit-slide.svg": "a3ee",
	"./meitav-dash/projection-slide.svg": "bb1d",
	"./meitav-dash/summary-slide.svg": "0114",
	"./meitav-dash/withdrawl-slide.svg": "f959"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";